module.exports = __webpack_public_path__ + "static/kuo_toa_archpriest-c8100d5b0d12564ee7f3d0607bb0912f.jpg";